const host =
  window.crgt && window.crgt.isProd ? 'https://static.ccrgt.com' : 'https://t-static.ccrgt.com';

export default {
  netCar: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'netcar/index',
    params: {
      needlogin: true,
    },
    isNativePage: true,
  },
  netCarOrder: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'netcar/index',
    params: {
      needlogin: true,
    },
    isNativePage: true,
  },
  foodOrdering: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'common/rn/FoodOrder',
    params: {
      needlogin: true,
    },
    isNativePage: true,
  },
  ticket: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'common/rn/TicketOrder',
    isNativePage: true,
    params: {
      needlogin: true,
    },
  },
  video: {
    type: 'openProtocol',
    path: 'openTab',
    protocol: 'action',
    params: {
      tab: 'video',
    },
    isNativePage: true,
  },
  vipLounge: {
    type: 'openUrl',
    path: `${host}/app-member/?_crgtwv=256#/vip-lounge?channelId=8`,
    needLogin: true,
    isNativePage: false,
  },
  hotel: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'common/rn/Hotel/pages/home/index',
    params: {
      needlogin: true,
    },
    isNativePage: true,
  },
  phoneRecharge: {
    type: 'openUrl',
    path: `${host}/phone-rechange/?_crgtwv=2#/`,
    needLogin: true,
    isNativePage: false,
  },
  youzan: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'youzan/youzan_mall',
    isNativePage: true,
  },
  youzanOrder: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'youzan/youzan_mall',
    params: {
      needlogin: true,
    },
    isNativePage: true,
  },
  rentCar: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'netcar/index',
    version: '2.2.8',
    params: {
      needlogin: true,
      tab: 'rentcar',
    },
    isNativePage: true,
  },
  redHat: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'common/rn/RedHatHome',
    isNativePage: true,
  },
  shareBus: {
    type: 'openProtocol',
    protocol: 'crgt',
    path: 'netcar/index',
    version: '2.3.3',
    params: {
      needlogin: true,
      tab: 'sharebus',
    },
    isNativePage: true,
  },
};
